<app-grid-client-side
    #appGridComponent
    [tableData]="tableData[0]"
    [fixedButtons]="fixedButtons"
    [idField]="'id'"
    (clickableButton)="crud($event)"
    feature="file_exporter"
></app-grid-client-side>